<template>
  <el-dialog
    title="我要吐槽"
    :visible.sync="visible"
    :before-close="cancelRoast"
    :destroy-on-close="true"
  >
    <el-form
        label-position="right"
        label-width="120px"
        :model="roastForm"
        :rules="roastFormRule"
        ref="roastForm"
        size="mini"
    >
      <el-form-item label="反馈类型" prop="type">
        <el-cascader
            popper-class="cascader-box"
            ref="cascader"
            v-model="roastForm.type"
            :props="props"
            :options="roastTypeOptions"
            clearable
            style="width:300px"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="邮箱地址" prop="email">
        <el-input v-model="roastForm.email"></el-input>
      </el-form-item>
      <el-form-item label="反馈内容" prop="content">
        <el-input
            type="textarea"
            :rows="7"
            v-model="roastForm.content"
            placeholder="请输入反馈内容"
            :maxlength="500"
            show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="cancelRoast">取 消</el-button>
      <el-button size="mini" type="primary" @click="validatForm(submitRoast)">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {getSuggestType, saveSuggest} from "../../api/frontApi";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      roastForm: {
        type: undefined, //反馈类型  1.现有功能吐槽 2.期望新增功能 3.界面交互体验不佳 4.其他问题
        content: "",
        email: "",
      },
      roastTypeOptions: [],
      roastFormRule: {
        type: [{ required: true, message: "请选择反馈类型" }],
        content: [{ required: true, message: "反馈内容不能为空" }],
        email: [{ type: 'email', message: '请输入正确的邮箱地址' }],
      },
      props: {
        value: "type",
        label: "typeName",
        children: "optionals",
        checkStrictly: true
      },
    };
  },
  created() {
    this.getType()
  },
  methods: {
    // 验证数据
    validatForm(callback) {
      const $form = this.$refs.roastForm;
      $form.validate((valid) => {
        if (valid) {
          callback();
        }
      });
    },

    // get吐槽类型
    async getType() {
      const {data}  = await getSuggestType()
      this.roastTypeOptions = data
    },

    // 提交吐槽
    async submitRoast() {
      try {
        const nodesInfo = this.$refs['cascader'].getCheckedNodes()
        const temp = {
          ...this.roastForm,
          type: this.roastForm.type[0],
          optional: this.roastForm.type[1],
          typeName: nodesInfo[0].pathLabels[0],
          optionalName: nodesInfo[0].pathLabels[1],
        }

        await saveSuggest(temp)
        this.$message({
          type: "success",
          message: `吐槽成功！`,
        });
        this.cancelRoast()
      } catch (error) {
        this.$message({
          type: "error",
          message: error.message,
        });
      }
    },

    // 取消
    cancelRoast() {
      this.roastForm = {
        type: undefined,
        content: "",
        email: "",
      },
      this.$emit('update:visible', false)
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
